import { inject } from "vue";
/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const INSIDE_RADIO_GROUP_KEY = /* @__PURE__ */ Symbol.for("insideRadioGroup");
function useInsideRadioGroup() {
  return inject(INSIDE_RADIO_GROUP_KEY, void 0);
}
export {
  INSIDE_RADIO_GROUP_KEY as I,
  useInsideRadioGroup as u
};
//# sourceMappingURL=useNcRadioGroup.mjs.map
